<template>
    <!-- Esto falla al hacer el mounted  -->
    <app-modal v-if="active" @modal-close="close">
        <div
            class="modal__box  modal__box--xlarge"
        >
            <div>
                <app-heading element="h3" class="modal__ttl">Preview of <strong>{{ info.name }}</strong></app-heading>

                <div class="flex flex-wrap">
                    <div class="w-3/5 box-preview flex justify-center" :class="cssType">

                        <template v-if="info.type == 'image'">
                            <app-image-info :file="info" />
                        </template>

                        <template v-else-if="info.type == 'audio'">
                            <audio ref="audio" controls>
                                <source :src="info.src" :type="info.mime"/>
                            </audio>
                        </template>

                        <template v-else-if="info.type == 'video'">
                            <video ref="video" controls crossorigin playsinline>
                                <source :src="info.url" :type="info.mime"/>
                            </video>
                        </template>


                        <template v-else-if="info.type == 'text'">
                            <app-codemirror 
                                v-if="codeLoaded" 
                                ref="code" 
                                :value="info.source" 
                                :options="cmOptions"
                            />
                        </template>

                        <template v-else-if="info.type == 'zip'">
                            <app-tree-view 
                                v-if="zipLoaded" 
                                :json="info.source" 
                                :name="info.name"
                            />
                        </template>

                        <!-- <template v-else-if="info.type == 'word'">
                            <iframe :src="'https://view.officeapps.live.com/op/embed.aspx?src='+info.url" width="100%" height="100%" style="border: none;">
                                <object class="no-preview" v-html="info.image"></object>
                            </iframe>
                        </template> -->

                        <template v-else-if="info.type == 'pdf'">
                            <object :data="info.url" type="application/pdf" width="100%" height="100%">
                                <iframe :src="info.url" width="100%" height="100%" style="border: none;">
                                    <object class="no-preview" v-html="info.image">

                                    </object>
                                </iframe>
                            </object>
                        </template>

                        <template v-else>
                            <object class="no-preview" v-html="info.image">

                            </object>
                        </template>


                    </div>
                    <div class="w-2/5 bg-30 box-info flex flex-wrap">

                        <div class="info-data w-full">
                            <div class="info mx-4 my-3 flex">
                                <span class="title font-bold px-1 py-1 rounded-l">Name:</span>
                                <span class="value px-1 py-1 rounded-r overflow-hidden">{{ info.name }}</span>
                            </div>

                            <div class="info mx-4 my-3 flex" v-if="info.mime">
                                <span class="title font-bold px-1 py-1 rounded-l">Mime Type:</span>
                                <span class="value px-1 py-1 rounded-r overflow-hidden">{{ info.mime }}</span>
                            </div>

                            <div class="info mx-4 my-3 flex" v-if="info.date">
                                <span class="title font-bold px-1 py-1 rounded-l">Last Modification:</span>
                                <span class="value px-1 py-1 rounded-r overflow-hidden">{{ info.date }}</span>
                            </div>

                            <div class="info mx-4 my-3 flex" v-if="info.size">
                                <span class="title font-bold px-1 py-1 rounded-l">Size:</span>
                                <span class="value px-1 py-1 rounded-r overflow-hidden">{{ info.size }}</span>
                            </div>

                            <div class="info mx-4 my-3 flex" v-if="info.dimensions">
                                <span class="title font-bold px-1 py-1 rounded-l">Dimensions:</span>
                                <span class="value px-1 py-1 rounded-r overflow-hidden">{{ info.dimensions }}</span>
                            </div>

                            <div class="info mx-4 mt-6" v-if="info.url">
                                <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-value">
                                    Url
                                </label>

                                <div class="flex flex-wrap items-stretch w-full mb-4 relative">
                                    <input type="text" class="flex-shrink flex-grow flex-auto text-xs leading-normal w-px flex-1 px-1 relative" style="border: none; outline: 0;" readonly="" :value="info.url">
                                    <div class="flex -mr-px">
                                        <app-button element="div" class="btn btn--tertiary btn--tertiary--sml" v-copy="info.url" v-copy:callback="onCopy">
                                            Copy
                                        </app-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal__footer">
                <div class="flex items-center ml-auto">
                    <app-confirmation-button
                        :messages="messagesRemove"
                        :css="'btn btn--rounded btn--red mr-2'"
                        v-on:confirmation-success="removeFilePopup()"
                    />
                    <app-button element="div" class="btn btn--secondary btn--secondary--sml mr-4" @click="closePreview">
                        Close
                    </app-button>
                    <template v-if="popup">
                        <app-button element="div" class="btn btn--primary btn--primary--sml" @click="selectFile">
                            Select file
                        </app-button>
                    </template>
                </div>
            </div>
        </div>
    </app-modal>
</template>

<script>
import api from '@/components/filemanager/api';
import Heading from '@/components/Heading';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import ImageInfo from '@/components/filemanager/modules/Image';
import ConfirmationButton from '@/components/filemanager/ConfirmationButton';
import TreeView from '@/components/filemanager/TreeView';
import { copy } from 'v-copy';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import { codemirror } from 'vue-codemirror';

//themes
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/dracula.css';

//modes
import 'codemirror/mode/markdown/markdown';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/php/php';
import 'codemirror/mode/sql/sql';
import 'codemirror/mode/ruby/ruby';
import 'codemirror/mode/shell/shell';
import 'codemirror/mode/sass/sass';
import 'codemirror/mode/yaml/yaml';
import 'codemirror/mode/yaml-frontmatter/yaml-frontmatter';
import 'codemirror/mode/nginx/nginx';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/vue/vue';
import 'codemirror/mode/dockerfile/dockerfile';
import 'codemirror/keymap/vim';

export default {
    props: {
        active: {
            type: Boolean,
            default: false,
            required: true,
        },
        info: {
            type: Object,
            default: function() {
                return { name: '' };
            },
            required: true,
        },
        popup: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    components: {
        'app-image-info': ImageInfo,
        'app-confirmation-button': ConfirmationButton,
        'app-tree-view': TreeView,
        'app-heading': Heading,
        'app-button': Button,
        'app-modal': Modal,
        'app-codemirror': codemirror,
    },

    directives: {
        copy,
    },

    data: () => ({
        messagesRemove: ['Remove File', 'Are you sure', 'Removing...'],
        cssType: ' py-custom',
        codeLoaded: false,
        zipLoaded: false,
        cmOptions: {
            tabSize: 2,
            theme: 'dracula',
            lineNumbers: true,
            line: true,
        },
    }),

    methods: {
        close() {
            this.$emit('info-close')
        },

        closePreview() {
            this.$emit('closePreview', true);
        },

        onCopy() {
            this.$toasted.show('Text copied to clipboard', { type: 'success' });
        },

        removeFilePopup() {
            this.closePreview();

            return api.removeFile(this.info.path).then(result => {
                if (result == true) {
                    this.$toasted.show('File removed successfully', { type: 'success' });
                    this.$emit('refresh');
                } else {
                    this.$toasted.show(
                        'Error removing the file. Please check permissions',
                        { type: 'error' }
                    );
                }
            });
        },

        selectFile() {
            this.closePreview();
            this.$emit('selectFile', this.info);
        },
    },

    mounted() {
        this.$nextTick(function() {
            this.messagesRemove = [
                'Remove file',
                'Are you sure?',
                'Removing...',
            ];
        });
    },

    computed: {
        playerOptions() {
            if (this.info) {
                return {
                    video: {
                        url: this.info.name,
                    },
                    autoplay: false,
                    contextmenu: [
                        {
                            text: 'GitHub',
                            link: 'https://github.com/MoePlayer/vue-dplayer',
                        },
                    ],
                };
            }
            return {};
        },
    },

    updated() {},

    watch: {
        'info.type': function(type) {
            if (type == 'audio') {
                this.$nextTick(function() {
                    setTimeout(() => {
                        this.cssType = ' py-custom items-center';
                        new Plyr(this.$refs.audio);
                    });
                });
            }

            if (type == 'video') {
                this.$nextTick(function() {
                    setTimeout(() => {
                        // this.cssType = 'items-center';
                        new Plyr(this.$refs.video);
                    });
                });
            }

            if (type == 'text') {
                this.$nextTick(function() {
                    this.cssType = '';
                    this.cmOptions.mode = this.info.mime;
                    this.codeLoaded = true;
                });
            }

            if (type == 'pdf') {
                this.$nextTick(function() {
                    this.cssType = 'mh400';
                });
            }

            if (type == 'zip') {
                this.$nextTick(function() {
                    this.info.source = JSON.parse(this.info.source);
                    this.zipLoaded = true;
                });
            }

            this.cssType = '';
            this.codeLoaded = false;
            this.zipLoaded = false;
        },
    },
};
</script>

<style scoped lang="scss">
.buttons-actions {
    padding-left: 1rem;
    padding-right: 1rem;
    border-left: 1px solid rgb(221, 221, 221);
    // border-bottom: 1px solid rgb(221, 221, 221);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.box-preview {
    max-height: 500px;
}

.py-custom {
    padding: 2rem 0;
}

.info {
    .title,
    .value {
        font-size: 0.75rem;
    }

    .value {
        //-moz-user-select: text;
        -khtml-user-select: text;
        -webkit-user-select: text;
        -ms-user-select: text;
        user-select: text;
    }

    .copy {
        &:active,
        &:focus {
            outline: 0;
        }
    }
}

.vue-codemirror {
    width: 100%;
}

.mh400 {
    min-height: 400px;
}
</style>

<style>
.no-preview > .svg-mime {
    width: 150px;
    height: 100%;
}
.CodeMirror {
    height: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/filemanager/DetailPopup.vue